module.exports = __webpack_public_path__ + "static/media/Lato-Black.f21ec1ef.eot";